import * as Actions from '../../../../redux/actions'

import {
    EmailAddressTextFieldCompanion,
    FirstNameTextFieldCompanion,
    LastNameTextFieldCompanion,
} from "../../Common/FormComponentsBank"

import { CheckLightIcon } from "../../Common/SVGBank"
import Fab from '@material-ui/core/Fab'
import React from 'react'
import { UserPlusIcon } from "../../Common/SVGBank"
import {
    companionTextFieldUseStyles,
} from "../../Common/ComponentsStylingBank"
import { connect } from 'react-redux'
import { member_area_router } from "../../Common/RegExValidate"
import { PostAsyncHelper } from '../../../../redux/interfaces/types'
import { environment } from "../../../../Environments/environment"

export const TripCompanion = ({ fetchTripCompanionSets, switch_container, cleanLastNameCompanion, cleanEmailAddressCompanion, cleanFirstNameCompanion, emailAddressTextFieldCompanion, firstNameTextFieldCompanion, lastNameTextFieldCompanion, tripCompanionSets, activeTripId, uuid, lang, alertBar }) => {
    const [loaded, setLoaded] = React.useState(false)
    const [open, setOpen] = React.useState(false)
    const classesTextField = companionTextFieldUseStyles();

    React.useEffect(() => {
        if (!loaded) {
            fetchTripCompanionSets(activeTripId, uuid, lang)
        }
        setLoaded(true)
    }, [activeTripId])


    const inviteHandler = async () => {
        if (emailAddressTextFieldCompanion !== undefined
            && firstNameTextFieldCompanion !== undefined
            && lastNameTextFieldCompanion !== undefined
            && emailAddressTextFieldCompanion.emailAddress !== "" && !emailAddressTextFieldCompanion.error
            && firstNameTextFieldCompanion.firstName !== "" && !firstNameTextFieldCompanion.error
            && lastNameTextFieldCompanion.lastName !== "" && !lastNameTextFieldCompanion.error) {
            try {
                const url = environment.apiUrl + 'memberarea/trip/addTripCompanions/' + lang + '/' + uuid
                const payload = {
                    tripId: activeTripId,
                    companions: [
                        {
                            firstName: firstNameTextFieldCompanion.firstName,
                            lastName: lastNameTextFieldCompanion.lastName,
                            email: emailAddressTextFieldCompanion.emailAddress,
                            genderId: "",
                            age: "",
                        }
                    ]
                }
                const response = await PostAsyncHelper(url, payload)
                if (response && response.statusText === "OK") {
                    fetchTripCompanionSets(activeTripId, uuid, lang)
                    cleanFirstNameCompanion()
                    cleanLastNameCompanion()
                    cleanEmailAddressCompanion()
                    setOpen(false)
                    alertBar("success", "Invitation sent")
                } else {
                    alertBar("error", "Failed to send invitation")
                }
            } catch (e) {
                alertBar("error", "Failed to send invitation")
            }
        }
    }

    const removeCompanionHandler = async (email) => {
        try {
            const url = environment.apiUrl + 'memberarea/trip/deleteTripCompanion/' + lang + '/' + uuid
            const payload = { tripId: activeTripId, email: email }
            const response = await PostAsyncHelper(url, payload)
            if (response && response.statusText === 'OK') {
                alertBar('success', 'Companion removed')
                fetchTripCompanionSets(activeTripId, uuid, lang)
            } else {
                alertBar('error', 'Failed to remove companion')
            }
        } catch (e) {
            alertBar('error', 'Failed to remove companion')
        }
    }
    return (
        <React.Fragment>
            {switch_container === member_area_router.memberAreaTrip ?

                <React.Fragment>
                    <div style={{ font: "23px/25px Futura Md BT", color: "#FFFFFF", textAlign: "left", paddingBottom: "25px" }}>{"Travelers"}</div>
                    <div style={{ display: "flex", flexWrap: "wrap", paddingBottom: "25px", alignItems: "flex-start" }}>
                        {tripCompanionSets !== undefined && tripCompanionSets.length > 0 && tripCompanionSets.map((companion, companion_index) => {
                            const name = `${companion.firstName || companion.first_name || ''} ${companion.lastName || companion.last_name || ''}`.trim()
                            const handle = companion.muverHandle || companion.handle || ''
                            const avatar = companion.profileImage || companion.avatar || "/img/no_profile.png"
                            const email = companion.email
                            return (
                                <div key={companion_index} style={{ width: "95px", margin: "0 10px 15px 0", textAlign: "center" }}>
                                    <div style={{ position: "relative" }}>
                                        <img src={avatar} alt={name} style={{ width: "75px", height: "75px", borderRadius: "50%", objectFit: "cover" }} />
                                        {email && <div onClick={() => removeCompanionHandler(email)} style={{ cursor: "pointer", position: "absolute", right: "-6px", top: "-6px", background: "#ff4d4f", color: "#fff", width: "22px", height: "22px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", font: "12px/12px Futura Md BT" }}>×</div>}
                                    </div>
                                    <div style={{ color: "#C7C7C7", font: "12px/14px Futura Lt BT", marginTop: "6px" }}>{handle ? `@${handle}` : ''}</div>
                                    <div style={{ color: "#FFFFFF", font: "12px/14px Futura Md BT" }}>{name}</div>
                                </div>
                            )
                        })}
                        <div style={{ width: "95px", margin: "0 10px 15px 0", textAlign: "center" }} onClick={() => setOpen(true)}>
                            <Fab disabled={false} style={{ margin: "0 0 5px 0", outline: "0px", backgroundColor: "#FFFFFF50", width: "75px", height: "75px", }}>
                                <UserPlusIcon />
                            </Fab>
                            <div style={{ color: "#C7C7C7", font: "14px/14px Futura Md BT", }}>{"+ add a travel companion"}</div>
                        </div>
                    </div>
                    {open && <div style={{ display: "flex", position: "relative" }}>
                        <div className={classesTextField.root} style={{ width: "50%", padding: "10px" }}>
                            <EmailAddressTextFieldCompanion
                                label="Email Address"
                                required={true}
                                id="email_address_companion"
                            />
                        </div>
                        <div className={classesTextField.root} style={{ width: "25%", padding: "10px" }}>
                            <FirstNameTextFieldCompanion
                                label="First Name"
                                required={true}
                                id="first_name_companion"
                            />
                        </div>
                        <div className={classesTextField.root} style={{ width: "25%", padding: "10px" }}>
                            <LastNameTextFieldCompanion
                                label="Last Name"
                                required={true}
                                id="last_name_companion"
                            />
                        </div>
                        {emailAddressTextFieldCompanion !== undefined
                            && firstNameTextFieldCompanion !== undefined
                            && lastNameTextFieldCompanion !== undefined
                            && emailAddressTextFieldCompanion.emailAddress !== "" && !emailAddressTextFieldCompanion.error
                            && firstNameTextFieldCompanion.firstName !== "" && !firstNameTextFieldCompanion.error
                            && lastNameTextFieldCompanion.lastName !== "" && !lastNameTextFieldCompanion.error &&
                            <div
                                onClick={() => inviteHandler()}
                                style={{ cursor: "pointer", position: "absolute", right: "-100px", top: "25px", font: "18px/25px Futura Md BT", color: "#19EC9E", }}>
                                <CheckLightIcon width={30} height={30} style={{ marginRight: "10px" }} /> {"Invite"}
                            </div>}
                    </div>}
                </React.Fragment > :
                <React.Fragment>
                    <div style={{ font: "23px/25px Futura Md BT", color: "#191919", textAlign: "left", paddingBottom: "10px" }}>{"Travelers"}</div>
                    <div style={{ display: "flex", flexWrap: "wrap", paddingBottom: "25px", alignItems: "flex-start" }}>
                        {tripCompanionSets !== undefined && tripCompanionSets.length > 0 && tripCompanionSets.map((companion, companion_index) => {
                            const name = `${companion.firstName || companion.first_name || ''} ${companion.lastName || companion.last_name || ''}`.trim()
                            const handle = companion.muverHandle || companion.handle || ''
                            const avatar = companion.profileImage || companion.avatar || "/img/no_profile.png"
                            const email = companion.email
                            return (
                                <div key={companion_index} style={{ width: "95px", margin: "0 10px 15px 0", textAlign: "center" }}>
                                    <div style={{ position: "relative" }}>
                                        <img src={avatar} alt={name} style={{ width: "75px", height: "75px", borderRadius: "50%", objectFit: "cover" }} />
                                        {email && <div onClick={() => removeCompanionHandler(email)} style={{ cursor: "pointer", position: "absolute", right: "-6px", top: "-6px", background: "#ff4d4f", color: "#fff", width: "22px", height: "22px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", font: "12px/12px Futura Md BT" }}>×</div>}
                                    </div>
                                    <div style={{ color: "#C7C7C7", font: "12px/14px Futura Lt BT", marginTop: "6px" }}>{handle ? `@${handle}` : ''}</div>
                                    <div style={{ color: "#191919", font: "12px/14px Futura Md BT" }}>{name}</div>
                                </div>
                            )
                        })}
                        <div style={{ width: "95px", margin: "0 10px 15px 0", textAlign: "center" }} onClick={() => setOpen(true)}>
                            <Fab disabled={false} style={{ margin: "0 0 5px 0", outline: "0px", backgroundColor: "#19191950", width: "75px", height: "75px", }}>
                                <UserPlusIcon />
                            </Fab>
                            <div style={{ color: "#191919", font: "14px/14px Futura Lt BT", }}>{"+ add a travel companion"}</div>
                        </div>
                    </div>
                    {open && <div style={{ display: "flex", position: "relative" }}>
                        <div className={classesTextField.root} style={{ width: "50%", padding: "10px" }}>
                            <EmailAddressTextFieldCompanion
                                label="Email Address"
                                required={true}
                                id="email_address_companion"
                            />
                        </div>
                        <div className={classesTextField.root} style={{ width: "25%", padding: "10px" }}>
                            <FirstNameTextFieldCompanion
                                label="First Name"
                                required={true}
                                id="first_name_companion"
                            />
                        </div>
                        <div className={classesTextField.root} style={{ width: "25%", padding: "10px" }}>
                            <LastNameTextFieldCompanion
                                label="Last Name"
                                required={true}
                                id="last_name_companion"
                            />
                        </div>
                        {emailAddressTextFieldCompanion !== undefined
                            && firstNameTextFieldCompanion !== undefined
                            && lastNameTextFieldCompanion !== undefined
                            && emailAddressTextFieldCompanion.emailAddress !== "" && !emailAddressTextFieldCompanion.error
                            && firstNameTextFieldCompanion.firstName !== "" && !firstNameTextFieldCompanion.error
                            && lastNameTextFieldCompanion.lastName !== "" && !lastNameTextFieldCompanion.error &&
                            <div
                                onClick={() => inviteHandler()}
                                style={{ cursor: "pointer", position: "absolute", right: "-100px", top: "25px", font: "18px/25px Futura Md BT", color: "#19EC9E", }}>
                                <CheckLightIcon width={30} height={30} style={{ marginRight: "10px" }} /> {"Invite"}
                            </div>}
                    </div>}
                </React.Fragment >
            }
        </React.Fragment >

    )
}

const mapStateToProps = (state) => ({
    tripCompanionSets: state.FormBank.TimelineWizard.activeTrip.tripCompanion.sets,
    activeTripId: state.FormBank.TimelineWizard.activeTrip.tripId,
    emailAddressTextFieldCompanion: state.FormBank.emailAddressTextFieldCompanion,
    firstNameTextFieldCompanion: state.FormBank.firstNameTextFieldCompanion,
    lastNameTextFieldCompanion: state.FormBank.lastNameTextFieldCompanion,

    lang: state.Setting.lang,
    uuid: state.Member.authModal.uuid,

    switch_container: state.Member.switch_container,
})

const mapDispatchToProps = {
    fetchTripCompanionSets: Actions.fetchTripCompanionSets,
    setTripCompanion: Actions.setTripCompanion,
    cleanLastNameCompanion: Actions.cleanLastNameCompanion,
    cleanFirstNameCompanion: Actions.cleanFirstNameCompanion,
    cleanEmailAddressCompanion: Actions.cleanEmailAddressCompanion,
    alertBar: Actions.alertBar,
}

export default connect(mapStateToProps, mapDispatchToProps)(TripCompanion)

